import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-bell',
  standalone: true,
  templateUrl: '../../assets/bell.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamBellIcon {}
